import React, { useState } from "react"
import { useContacto } from "../hooks/contacto/useContacto"
import Swal from "sweetalert2"

export default function Contacto() {
  const [email, setEmail] = useState("")
  const [msg, setMsg] = useState("")
  const { enviarContacto, loading, error, success } = useContacto()

  const handleSubmit = async (e) => {
    e.preventDefault()
    await enviarContacto(email, msg)

    if (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error,
        confirmButtonColor: "#ef4444", // rojo
      })
    }

    if (success) {
      Swal.fire({
        icon: "success",
        title: "¡Mensaje enviado!",
        text: "Tu mensaje fue registrado correctamente.",
        confirmButtonColor: "#4f46e5", // indigo
      })
    }

    setEmail("")
    setMsg("")
  }

  return (
    <main className="max-w-5xl mx-auto px-6 py-12 space-y-8">
      {/* Encabezado */}
      <section className="text-center space-y-2">
        <h1 className="text-4xl font-extrabold text-gray-900">Contáctanos</h1>
        <p className="text-lg text-gray-600">
          ¿Tienes preguntas o quieres afiliar tu comercio? Estamos aquí para
          ayudarte.
        </p>
      </section>

      {/* Formulario */}
      <form
        onSubmit={handleSubmit}
        className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl shadow-lg p-8 max-w-2xl mx-auto space-y-6"
      >
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Tu correo electrónico
          </label>
          <input
            id="email"
            type="email"
            className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            placeholder="ejemplo@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div>
          <label
            htmlFor="msg"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Tu mensaje
          </label>
          <textarea
            id="msg"
            className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            placeholder="Escribe tu mensaje aquí..."
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            rows={6}
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 px-6 rounded-lg bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 transition"
        >
          {loading ? "Enviando..." : "📩 Enviar mensaje"}
        </button>
      </form>

      {/* Redes sociales */}
      <section className="text-center text-gray-700">
        <p className="text-sm">
          También puedes encontrarnos en Instagram y Facebook como{" "}
          <span className="font-semibold text-indigo-600">@quipusmania</span>.
        </p>
      </section>
    </main>
  )
}
